import { render } from "./XinbActive.vue?vue&type=template&id=2128b97a&scoped=true"
import script from "./XinbActive.vue?vue&type=script&lang=js"
export * from "./XinbActive.vue?vue&type=script&lang=js"

import "./XinbActive.vue?vue&type=style&index=0&id=2128b97a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2128b97a"]])

export default __exports__